import { oceanBlueColor, grayColor, whiteColor } from "../../cmsMainStyle";

const recipientChipStyle = (theme) => ({
  root: {
    display: "inline-flex",
    "& > *": {
      // margin: theme.spacing(1),
      // height: theme.spacing(4)
    },
  },

  paper: {
    display: "flex",
    alignItems: "center",
    height: theme.spacing(4),
    borderRadius: "50px",
    borderColor: oceanBlueColor[3],
    cursor: "pointer",
  },

  avatar: {
    backgroundColor: "var(--avatar-color)",
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
    marginLeft: theme.spacing(0.5),
    color: grayColor[12],
  },

  actionBtnGroup: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: theme.spacing(0.5),
  },

  actionBtn: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginLeft: theme.spacing(0.5),
    backgroundColor: grayColor[4],
  },

  actionBtnIcon: {
    // color: whiteColor,
    color: "var(--icon-color)",
  },

  chipContent: {
    color: grayColor[12],
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },

  // avatar: {
  // 	backgroundColor: "var(--avatar-color)"
  // },

  chip: {
    color: grayColor[12],
    borderColor: oceanBlueColor[3],
  },
});

export default recipientChipStyle;
